export const REGULAR = 'regular';
export const PAGE_BROWSE = 'in page browse';
export const BUNDLED = 'bundled';
export const SINGLE = 'single';
export const SAME_DAY = 'same day';
export const VIEW = 'view';
export const LINK = 'link';
export const ON = '1';
export const OFF = '0';
export const NOT_APPLICABLE = 'na';

export const SPECIALORDERSHIPTOSTORE = 'Special Order Ships to Store';
export const INSTOCKONLINE = 'in stock online';
export const OUTOFSTOCK = 'Out Of Stock';
export const NOTAVAILABLE = 'not available at';
export const INSTOREPICKUP = 'In-Store Pickup Available';
export const SPECIALORDERSHIPTOSTOREOUTOFSTOCK = 'Special Orders Ships to Store Not Available for This Location.';

export const NEARBY_PICKUP_ORDER = 'nearby_store_pickup_here_order';
export const NEARBY_PICKUP_CLICK = 'nearby_store_pickup_here_click';
export const NEARBY_SESSION_VALUE = 'nearbyItemAdded';

export const ONECLICK_CREATE_STORAGE = 'oneclickstorage';
export const ONECLICK_CREATE_SUCCESS = 'oneclickaccountcreate_order_success';
export const ONECLICK_CREATE_FAIL = 'oneclickaccountcreate_order_fail';
export const ONECLICK_CREATE_SUCCESS_ORDER_FAIL = 'oneclickaccountcreate_success_order_fail';

export const CART_INFO = 'cartInfo';
export const CART_INFO_LOAD = 'cartInfoLoad';
export const KEY_WAS_NOW_PRICE = 'wasNowPrice';
export const KEY_PRICE_IN_CART = 'priceInCart';

export const DELIVERY_METHODS_ANALYTICS = {
  STORE_PICK_UP: 'sp',
  ONLINE_ONLY: 'oo',
  IN_STORE_ONLY: 'io',
  SHIP_TO_STORE: 'ss',
  SHIPPING: 'sh',
  OUT_OF_STOCK: 'oos',
  NOT_AVAILABLE: 'na',
  E_GIFT_CARD: 'egc',
  DOORDASH: 'dd',
};
export const CHASE_PAYMENT = 'Ch';
export const SEZZLE_TYPE = 'sezzleType';
export const JPMC_ORBITAL = 'jpmc_orbital';
export const DIRECT_INTEGRATION = 'direct_integration';
export const PAYEEZY = 'payeezy';
export const RTS = 'rts';
export const GOOGLE_PAY = 'GooglePay';
export const APPLE_PAY = 'ApplePay';
export const PAYPAL = 'PayPal';
export const PLCC = 'PLCC';
export const CC = 'creditCard';
export const GC = 'giftCard';
export const VENMO = 'Venmo';
export const KLARNA = 'Klarna';
export const SEZZLE = 'Sezzle';
export const SEZZLE_DIRECT = 'sezzle_direct';
export const BREAD_PAY = 'breadPay';
export const PAYEEZY_FALLBACK_SESSION_VARIABLE = 'payment_route|set|session_variable';
export const CHASE_GOOGLE_PAY = 'googlePay';
export const CHASE_APPLE_PAY = 'applePay';
export const BREAD_SPLITPAY = 'BreadPay_SplitPay';
export const BREAD_INSTALLMENTS = 'BreadPay_Installments';
export const INSTALLMENTS = 'installments';
export const BREAD_PAY_LOWERCASE = 'bread pay';
export const SPLITPAY = 'splitpay';
export const GC_CC = 'gc/cc';
export const RTS_PAYZEE = 'rts/payeezy';
export const RTS_JPMC_ORBITAL = 'rts/jpmc_orbital';

// Meta Additional Attribute Constants
export const USER_PROFILE_DATA = 'userProfileData';
export const phoneNumber = 'phoneNumber';
export const zipCode = 'zipCode';
